import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

const ROUTE_META: Record<string, { title: string; subtitle?: string }> = {
  '/wizard': {
    title: 'Lean-of-Peak Procedure',
    subtitle: 'Step-by-step guide. Enter your engine monitor values as you lean.',
  },
  '/monitor': {
    title: 'Engine Monitor',
    subtitle: 'Enter current EGT / CHT per cylinder. Peaks are tracked live.',
  },
  '/runup': {
    title: 'Run-up Assistant',
    subtitle: '1,800 RPM · lean · magneto check · enter EGT rise per side.',
  },
  '/troubleshoot': {
    title: 'Troubleshoot',
    subtitle: 'Diagnose EGT / CHT patterns — from pattern to action.',
  },
  '/settings': {
    title: 'Settings',
    subtitle: 'Engine configuration, personal CHT limits, units.',
  },
};

export function Layout() {
  const location = useLocation();
  const meta = ROUTE_META[location.pathname] ?? { title: 'Lean Assist' };
  return (
    <div className="ipad-screen">
      <Sidebar />
      <main className="main">
        <Topbar title={meta.title} subtitle={meta.subtitle} />
        <div className="content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
